var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.isMobileVertical
    ? _c(
        "div",
        {
          staticClass: "footer-wrapper",
          class: {
            "footer-wrapper--cockfight-dice": _vm.showCockfightDice,
            "footer-wrapper--tai-xiu-bar": _vm.showTaiXiuBarFooter,
          },
        },
        [
          _vm.showCockfightDice
            ? _c(
                "div",
                { staticClass: "footer-wrapper__dice-slot" },
                [
                  _c("DiceLauncher", {
                    staticClass: "footer-wrapper__dice-tab",
                    on: { click: _vm.openTaiXiu },
                  }),
                ],
                1
              )
            : _vm._e(),
          _c("MobileFooterPanel", {
            attrs: { "cockfight-active": _vm.isCockfightActive },
            on: { "select-cockfight": _vm.onSelectCockfight },
          }),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }